import { combineReducers, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";

import { act } from "@testing-library/react";
import persistConfig from "./persistConfig";

// actions.js
export const activateGeod = (geod) => ({
  type: "ACTIVATE_GEOD",
  geod,
});

export const closeGeod = (geod) => ({
  type: "CLOSE_GEOD",
  geod,
});



export const intsallationDispenserDataRemove = (
  workOrderNo,
  customerName,
  productType,
  modelName,
  mcuBoardSoftwareSrNo,
  mcuBoardHardwareVersion,
  mcuBoardSrNo,
  mcuBoardSHA2,
  mcuBoardSignXBitBlock,
  mcuBoardPublicKey,
  mcuBoardPrivateKey,
  mcuBoardRCAPublicKey,
  csdBoardSoftwareSrNo,
  csdBoardHardwareVersion,
  csdBoardSrNo,
  csdBoardSHA2,
  csdBoardSignXBitBlock,
  csdBoardPublicKey,
  csdBoardPrivateKey,
  csdBoardRCAPublicKey,
  mreBoardSoftwareSrNo,
  mreBoardHardwareVersion,
  mreBoardSrNo,
  mreBoardSHA2,
  mreBoardSignXBitBlock,
  mreBoardPublicKey,
  mreBoardPrivateKey,
  mreBoardRCAPublicKey,
  sdlBoardSoftwareSrNo,
  sdlBoardHardwareVersion,
  sdlBoardSrNo,
  sdlBoardSHA2,
  sdlBoardSignXBitBlock,
  sdlBoardPublicKey,
  sdlBoardPrivateKey,
  sdlBoardRCAPublicKey,
  board1SoftwareSrNo,
  board1HardwareVersion,
  board1BoardSrNo,
  board1BoardSHA2,
  board1SignXBitBlock,
  board1PublicKey,
  board1PrivateKey,
  board1RCAPublicKey,
  board2SoftwareSrNo,
  board2HardwareVersion,
  board2BoardSrNo,
  board2BoardSHA2,
  board2SignXBitBlock,
  board2PublicKey,
  board2PrivateKey,
  board2RCAPublicKey,
  board3SoftwareSrNo,
  board3HardwareVersion,
  board3BoardSrNo,
  board3BoardSHA2,
  board3SignXBitBlock,
  board3PublicKey,
  board3PrivateKey,
  board3RCAPublicKey,
  board4SoftwareSrNo,
  board4HardwareVersion,
  board4BoardSrNo,
  board4BoardSHA2,
  board4SignXBitBlock,
  board4PublicKey,
  board4PrivateKey,
  board4RCAPublicKey,
  ) => ({
  type: "IntsallationDispenser_DetailsRemove",
  workOrderNo,
  customerName,
  productType,
  modelName,
  mcuBoardSoftwareSrNo,
  mcuBoardHardwareVersion,
  mcuBoardSrNo,
  mcuBoardSHA2,
  mcuBoardSignXBitBlock,
  mcuBoardPublicKey,
  mcuBoardPrivateKey,
  mcuBoardRCAPublicKey,
  csdBoardSoftwareSrNo,
  csdBoardHardwareVersion,
  csdBoardSrNo,
  csdBoardSHA2,
  csdBoardSignXBitBlock,
  csdBoardPublicKey,
  csdBoardPrivateKey,
  csdBoardRCAPublicKey,
  mreBoardSoftwareSrNo,
  mreBoardHardwareVersion,
  mreBoardSrNo,
  mreBoardSHA2,
  mreBoardSignXBitBlock,
  mreBoardPublicKey,
  mreBoardPrivateKey,
  mreBoardRCAPublicKey,
  sdlBoardSoftwareSrNo,
  sdlBoardHardwareVersion,
  sdlBoardSrNo,
  sdlBoardSHA2,
  sdlBoardSignXBitBlock,
  sdlBoardPublicKey,
  sdlBoardPrivateKey,
  sdlBoardRCAPublicKey,
  board1SoftwareSrNo,
  board1HardwareVersion,
  board1BoardSrNo,
  board1BoardSHA2,
  board1SignXBitBlock,
  board1PublicKey,
  board1PrivateKey,
  board1RCAPublicKey,
  board2SoftwareSrNo,
  board2HardwareVersion,
  board2BoardSrNo,
  board2BoardSHA2,
  board2SignXBitBlock,
  board2PublicKey,
  board2PrivateKey,
  board2RCAPublicKey,
  board3SoftwareSrNo,
  board3HardwareVersion,
  board3BoardSrNo,
  board3BoardSHA2,
  board3SignXBitBlock,
  board3PublicKey,
  board3PrivateKey,
  board3RCAPublicKey,
  board4SoftwareSrNo,
  board4HardwareVersion,
  board4BoardSrNo,
  board4BoardSHA2,
  board4SignXBitBlock,
  board4PublicKey,
  board4PrivateKey,
  board4RCAPublicKey,
});

// ........Installation.........//
export const intsallationDispenserData = ({
  workOrderNo,
  productType,
  generateUniqueDispenserNo,
  // modelName,
  // mcuBoardSoftwareSrNo,
  // mcuBoardHardwareVersion,
  // mcuBoardSrNo,
  // mcuBoardSHA2,
  // mcuBoardSignXBitBlock,
  // mcuBoardPublicKey,
  // mcuBoardPrivateKey,
  // mcuBoardRCAPublicKey,
  // csdBoardSoftwareSrNo,
  // csdBoardHardwareVersion,
  // csdBoardSrNo,
  // csdBoardSHA2,
  // csdBoardSignXBitBlock,
  // csdBoardPublicKey,
  // csdBoardPrivateKey,
  // csdBoardRCAPublicKey,
  // mreBoardSoftwareSrNo,
  // mreBoardHardwareVersion,
  // mreBoardSrNo,
  // mreBoardSHA2,
  // mreBoardSignXBitBlock,
  // mreBoardPublicKey,
  // mreBoardPrivateKey,
  // mreBoardRCAPublicKey,
  // sdlBoardSoftwareSrNo,
  // sdlBoardHardwareVersion,
  // sdlBoardSrNo,
  // sdlBoardSHA2,
  // sdlBoardSignXBitBlock,
  // sdlBoardPublicKey,
  // sdlBoardPrivateKey,
  // sdlBoardRCAPublicKey,
  // board1SoftwareSrNo,
  // board1HardwareVersion,
  // board1BoardSrNo,
  // board1BoardSHA2,
  // board1SignXBitBlock,
  // board1PublicKey,
  // board1PrivateKey,
  // board1RCAPublicKey,
  // board2SoftwareSrNo,
  // board2HardwareVersion,
  // board2BoardSrNo,
  // board2BoardSHA2,
  // board2SignXBitBlock,
  // board2PublicKey,
  // board2PrivateKey,
  // board2RCAPublicKey,
  // board3SoftwareSrNo,
  // board3HardwareVersion,
  // board3BoardSrNo,
  // board3BoardSHA2,
  // board3SignXBitBlock,
  // board3PublicKey,
  // board3PrivateKey,
  // board3RCAPublicKey,
  // board4SoftwareSrNo,
  // board4HardwareVersion,
  // board4BoardSrNo,
  // board4BoardSHA2,
  // board4SignXBitBlock,
  // board4PublicKey,
  // board4PrivateKey,
  // board4RCAPublicKey,

}) => ({
  type: "IntsallationDispenser_Details",
  workOrderNo,
  productType,
  generateUniqueDispenserNo,
  // modelName,
  // mcuBoardSoftwareSrNo,
  // mcuBoardHardwareVersion,
  // mcuBoardSrNo,
  // mcuBoardSHA2,
  // mcuBoardSignXBitBlock,
  // mcuBoardPublicKey,
  // mcuBoardPrivateKey,
  // mcuBoardRCAPublicKey,
  // csdBoardSoftwareSrNo,
  // csdBoardHardwareVersion,
  // csdBoardSrNo,
  // csdBoardSHA2,
  // csdBoardSignXBitBlock,
  // csdBoardPublicKey,
  // csdBoardPrivateKey,
  // csdBoardRCAPublicKey,
  // mreBoardSoftwareSrNo,
  // mreBoardHardwareVersion,
  // mreBoardSrNo,
  // mreBoardSHA2,
  // mreBoardSignXBitBlock,
  // mreBoardPublicKey,
  // mreBoardPrivateKey,
  // mreBoardRCAPublicKey,
  // sdlBoardSoftwareSrNo,
  // sdlBoardHardwareVersion,
  // sdlBoardSrNo,
  // sdlBoardSHA2,
  // sdlBoardSignXBitBlock,
  // sdlBoardPublicKey,
  // sdlBoardPrivateKey,
  // sdlBoardRCAPublicKey,
  // board1SoftwareSrNo,
  // board1HardwareVersion,
  // board1BoardSrNo,
  // board1BoardSHA2,
  // board1SignXBitBlock,
  // board1PublicKey,
  // board1PrivateKey,
  // board1RCAPublicKey,
  // board2SoftwareSrNo,
  // board2HardwareVersion,
  // board2BoardSrNo,
  // board2BoardSHA2,
  // board2SignXBitBlock,
  // board2PublicKey,
  // board2PrivateKey,
  // board2RCAPublicKey,
  // board3SoftwareSrNo,
  // board3HardwareVersion,
  // board3BoardSrNo,
  // board3BoardSHA2,
  // board3SignXBitBlock,
  // board3PublicKey,
  // board3PrivateKey,
  // board3RCAPublicKey,
  // board4SoftwareSrNo,
  // board4HardwareVersion,
  // board4BoardSrNo,
  // board4BoardSHA2,
  // board4SignXBitBlock,
  // board4PublicKey,
  // board4PrivateKey,
  // board4RCAPublicKey,
});
// export const installationOtpVarification = ({
//   generateUniqueDispenserNo,
//   jobNo,
//   otpVerification,
// }) => ({
//   type: "InstallationOtpVarification_Details",
//   generateUniqueDispenserNo,
//   jobNo,
//   otpVerification,
// });

export const addInstallation = ({
  // generateUniqueDispenserNo,
  jobNo,
  siteName,
  fkServiceEngineerId,
  serviceEngineerName,
  serviceEngineerMobNo,
  fkCustomerId,
  customerName,
  customerMobileNo,
  fkDealerId,
  dealerName,
  dealerMobileNo,
  siteAddress,
  siteType,
  uploadDispenserPhoto,
  installationDate,
  installationTime,
  installationStatus,
  // longitude,
  // latitude,
  remark,

}) => ({
  type: "AddInstallation_Details",
  // generateUniqueDispenserNo,
  jobNo,
  siteName,
  fkServiceEngineerId,
  serviceEngineerName,
  serviceEngineerMobNo,
  fkCustomerId,
  customerName,
  customerMobileNo,
  fkDealerId,
  dealerName,
  dealerMobileNo,
  siteAddress,
  siteType,
  uploadDispenserPhoto,
  installationDate,
  installationTime,
  installationStatus,
  // longitude,
  // latitude,
  remark,

});
// .......End Installation.........//


// .......Field Issue.........//
export const addFieldIssue = ({
jobNo,
fkServiceEngineerId,
serviceEngineerName,
serviceEngineerMobNo,
siteType,
siteName,
fkCustomerId,
customerName,
customerMobileNo,
fkDealerId,
dealerName,
fieldIssueDate,
fieldIssueTime,
siteAddress,
embelDeviceConnect,
uploadDispenserPhoto,
// longitude,
// latitude,
jobType,
remark,
}) => ({
  type: "AddFieldIssue_Details",
  jobNo,
  fkServiceEngineerId,
  serviceEngineerName,
  serviceEngineerMobNo,
  siteType,
  siteName,
  fkCustomerId,
  customerName,
  customerMobileNo,
  fkDealerId,
  dealerName,
  fieldIssueDate,
  fieldIssueTime,
  siteAddress,
  embelDeviceConnect,
  uploadDispenserPhoto,
  // longitude,
  // latitude,
  jobType,
  remark,
});

export const addArkField = ({
  arkNo,
  // generateUniqueDispenserNo,
  oprationType,
  subOprationType,
  volumeTotalizer,
}) => ({
  type: "AddArkField_Details",
  arkNo,
  // generateUniqueDispenserNo,
  oprationType,
  subOprationType,
  volumeTotalizer,
});

export const fieldIssueDispenserData = ({
  // workOrderNo,
  workOrderSerialNo,
  // customerName,
  // fkCustomerId,
  productType,
  generateUniqueDispenserNo,
  // modelName,
  // mcuBoardSoftwareSrNo,
  // mcuBoardHardwareVersion,
  // mcuBoardSrNo,
  // mcuBoardSHA2,
  // mcuBoardSignXBitBlock,
  // mcuBoardPublicKey,
  // mcuBoardPrivateKey,
  // mcuBoardRCAPublicKey,
  // csdBoardSoftwareSrNo,
  // csdBoardHardwareVersion,
  // csdBoardSrNo,
  // csdBoardSHA2,
  // csdBoardSignXBitBlock,
  // csdBoardPublicKey,
  // csdBoardPrivateKey,
  // csdBoardRCAPublicKey,
  // mreBoardSoftwareSrNo,
  // mreBoardHardwareVersion,
  // mreBoardSrNo,
  // mreBoardSHA2,
  // mreBoardSignXBitBlock,
  // mreBoardPublicKey,
  // mreBoardPrivateKey,
  // mreBoardRCAPublicKey,
  // sdlBoardSoftwareSrNo,
  // sdlBoardHardwareVersion,
  // sdlBoardSrNo,
  // sdlBoardSHA2,
  // sdlBoardSignXBitBlock,
  // sdlBoardPublicKey,
  // sdlBoardPrivateKey,
  // sdlBoardRCAPublicKey,
  // board1SoftwareSrNo,
  // board1HardwareVersion,
  // board1BoardSrNo,
  // board1BoardSHA2,
  // board1SignXBitBlock,
  // board1PublicKey,
  // board1PrivateKey,
  // board1RCAPublicKey,
  // board2SoftwareSrNo,
  // board2HardwareVersion,
  // board2BoardSrNo,
  // board2BoardSHA2,
  // board2SignXBitBlock,
  // board2PublicKey,
  // board2PrivateKey,
  // board2RCAPublicKey,
  // board3SoftwareSrNo,
  // board3HardwareVersion,
  // board3BoardSrNo,
  // board3BoardSHA2,
  // board3SignXBitBlock,
  // board3PublicKey,
  // board3PrivateKey,
  // board3RCAPublicKey,
  // board4SoftwareSrNo,
  // board4HardwareVersion,
  // board4BoardSrNo,
  // board4BoardSHA2,
  // board4SignXBitBlock,
  // board4PublicKey,
  // board4PrivateKey,
  // board4RCAPublicKey,
}) => ({
  type: "FieldDispenser_Details",
  // workOrderNo,
  workOrderSerialNo,
  // customerName,
  // fkCustomerId,
  productType,
  generateUniqueDispenserNo,
  // modelName,
  // mcuBoardSoftwareSrNo,
  // mcuBoardHardwareVersion,
  // mcuBoardSrNo,
  // mcuBoardSHA2,
  // mcuBoardSignXBitBlock,
  // mcuBoardPublicKey,
  // mcuBoardPrivateKey,
  // mcuBoardRCAPublicKey,
  // csdBoardSoftwareSrNo,
  // csdBoardHardwareVersion,
  // csdBoardSrNo,
  // csdBoardSHA2,
  // csdBoardSignXBitBlock,
  // csdBoardPublicKey,
  // csdBoardPrivateKey,
  // csdBoardRCAPublicKey,
  // mreBoardSoftwareSrNo,
  // mreBoardHardwareVersion,
  // mreBoardSrNo,
  // mreBoardSHA2,
  // mreBoardSignXBitBlock,
  // mreBoardPublicKey,
  // mreBoardPrivateKey,
  // mreBoardRCAPublicKey,
  // sdlBoardSoftwareSrNo,
  // sdlBoardHardwareVersion,
  // sdlBoardSrNo,
  // sdlBoardSHA2,
  // sdlBoardSignXBitBlock,
  // sdlBoardPublicKey,
  // sdlBoardPrivateKey,
  // sdlBoardRCAPublicKey,
  // board1SoftwareSrNo,
  // board1HardwareVersion,
  // board1BoardSrNo,
  // board1BoardSHA2,
  // board1SignXBitBlock,
  // board1PublicKey,
  // board1PrivateKey,
  // board1RCAPublicKey,
  // board2SoftwareSrNo,
  // board2HardwareVersion,
  // board2BoardSrNo,
  // board2BoardSHA2,
  // board2SignXBitBlock,
  // board2PublicKey,
  // board2PrivateKey,
  // board2RCAPublicKey,
  // board3SoftwareSrNo,
  // board3HardwareVersion,
  // board3BoardSrNo,
  // board3BoardSHA2,
  // board3SignXBitBlock,
  // board3PublicKey,
  // board3PrivateKey,
  // board3RCAPublicKey,
  // board4SoftwareSrNo,
  // board4HardwareVersion,
  // board4BoardSrNo,
  // board4BoardSHA2,
  // board4SignXBitBlock,
  // board4PublicKey,
  // board4PrivateKey,
  // board4RCAPublicKey,
});

// .......End Field Issue.........//

// .......Calibration.........//
export const calibrationDispenserData = ({
  // workOrderNo,
  workOrderSerialNo, // by bhushan
  productType,
  generateUniqueDispenserNo,
  // modelName,
  // mcuBoardSoftwareSrNo,
  // mcuBoardHardwareVersion,
  // mcuBoardSrNo,
  // mcuBoardSHA2,
  // mcuBoardSignXBitBlock,
  // mcuBoardPublicKey,
  // mcuBoardPrivateKey,
  // mcuBoardRCAPublicKey,
  // csdBoardSoftwareSrNo,
  // csdBoardHardwareVersion,
  // csdBoardSrNo,
  // csdBoardSHA2,
  // csdBoardSignXBitBlock,
  // csdBoardPublicKey,
  // csdBoardPrivateKey,
  // csdBoardRCAPublicKey,
  // mreBoardSoftwareSrNo,
  // mreBoardHardwareVersion,
  // mreBoardSrNo,
  // mreBoardSHA2,
  // mreBoardSignXBitBlock,
  // mreBoardPublicKey,
  // mreBoardPrivateKey,
  // mreBoardRCAPublicKey,
  // sdlBoardSoftwareSrNo,
  // sdlBoardHardwareVersion,
  // sdlBoardSrNo,
  // sdlBoardSHA2,
  // sdlBoardSignXBitBlock,
  // sdlBoardPublicKey,
  // sdlBoardPrivateKey,
  // sdlBoardRCAPublicKey,
  // board1SoftwareSrNo,
  // board1HardwareVersion,
  // board1BoardSrNo,
  // board1BoardSHA2,
  // board1SignXBitBlock,
  // board1PublicKey,
  // board1PrivateKey,
  // board1RCAPublicKey,
  // board2SoftwareSrNo,
  // board2HardwareVersion,
  // board2BoardSrNo,
  // board2BoardSHA2,
  // board2SignXBitBlock,
  // board2PublicKey,
  // board2PrivateKey,
  // board2RCAPublicKey,
  // board3SoftwareSrNo,
  // board3HardwareVersion,
  // board3BoardSrNo,
  // board3BoardSHA2,
  // board3SignXBitBlock,
  // board3PublicKey,
  // board3PrivateKey,
  // board3RCAPublicKey,
  // board4SoftwareSrNo,
  // board4HardwareVersion,
  // board4BoardSrNo,
  // board4BoardSHA2,
  // board4SignXBitBlock,
  // board4PublicKey,
  // board4PrivateKey,
  // board4RCAPublicKey,
}) => ({
  type: "CalibrationDispenser_Details",
  // workOrderNo,
  workOrderSerialNo, // by bhushan
  productType,
  generateUniqueDispenserNo,
  // modelName,
  // mcuBoardSoftwareSrNo,
  // mcuBoardHardwareVersion,
  // mcuBoardSrNo,
  // mcuBoardSHA2,
  // mcuBoardSignXBitBlock,
  // mcuBoardPublicKey,
  // mcuBoardPrivateKey,
  // mcuBoardRCAPublicKey,
  // csdBoardSoftwareSrNo,
  // csdBoardHardwareVersion,
  // csdBoardSrNo,
  // csdBoardSHA2,
  // csdBoardSignXBitBlock,
  // csdBoardPublicKey,
  // csdBoardPrivateKey,
  // csdBoardRCAPublicKey,
  // mreBoardSoftwareSrNo,
  // mreBoardHardwareVersion,
  // mreBoardSrNo,
  // mreBoardSHA2,
  // mreBoardSignXBitBlock,
  // mreBoardPublicKey,
  // mreBoardPrivateKey,
  // mreBoardRCAPublicKey,
  // sdlBoardSoftwareSrNo,
  // sdlBoardHardwareVersion,
  // sdlBoardSrNo,
  // sdlBoardSHA2,
  // sdlBoardSignXBitBlock,
  // sdlBoardPublicKey,
  // sdlBoardPrivateKey,
  // sdlBoardRCAPublicKey,
  // board1SoftwareSrNo,
  // board1HardwareVersion,
  // board1BoardSrNo,
  // board1BoardSHA2,
  // board1SignXBitBlock,
  // board1PublicKey,
  // board1PrivateKey,
  // board1RCAPublicKey,
  // board2SoftwareSrNo,
  // board2HardwareVersion,
  // board2BoardSrNo,
  // board2BoardSHA2,
  // board2SignXBitBlock,
  // board2PublicKey,
  // board2PrivateKey,
  // board2RCAPublicKey,
  // board3SoftwareSrNo,
  // board3HardwareVersion,
  // board3BoardSrNo,
  // board3BoardSHA2,
  // board3SignXBitBlock,
  // board3PublicKey,
  // board3PrivateKey,
  // board3RCAPublicKey,
  // board4SoftwareSrNo,
  // board4HardwareVersion,
  // board4BoardSrNo,
  // board4BoardSHA2,
  // board4SignXBitBlock,
  // board4PublicKey,
  // board4PrivateKey,
  // board4RCAPublicKey,
});
export const addArkCalibration = ({
  arkNo,
  // generateUniqueDispenserNo,
  oprationType,
  subOprationType,
  volumeTotalizer,
}) => ({
  type: "AddArkCalibration_Details",
  arkNo,
  // generateUniqueDispenserNo,
  oprationType,
  subOprationType,
  volumeTotalizer,
});

export const addCalibration = ({
  jobNo,
  calibrationDate,
  calibrationTime,
  inspectorName,
  inspectorMobileNo,
  fkCustomerId,
  customerName,
  customerMobileNo,
  fkDealerId,
  dealerName,
  dealerMobileNo,
  siteType,
  fkServiceEngineerId,
  serviceEngineerName,
  serviceEngineerMobNo,
  calibrationCertificate,
  certificateDatePhoto,
  certificateSignature,
  digitalSignature,
  siteReportUpload,
  calibrationLogView,
  sitePhoto,
  certificateDate,
  // longitude,
  // latitude,
  remark,
}) => ({
  type: "AddCalibration_Details",
  jobNo,
  calibrationDate,
  calibrationTime,
  inspectorName,
  inspectorMobileNo,
  fkCustomerId,
  customerName,
  customerMobileNo,
  fkDealerId,
  dealerName,
  dealerMobileNo,
  siteType,
  fkServiceEngineerId,
  serviceEngineerName,
  serviceEngineerMobNo,
  calibrationCertificate,
  certificateDatePhoto,
  certificateSignature,
  digitalSignature,
  siteReportUpload,
  calibrationLogView,
  sitePhoto,
  certificateDate,
  // longitude,
  // latitude,
  remark,
});


// reducers.js
export const geod = (state = {}, action) => {
  switch (action.type) {
    case "ACTIVATE_GEOD":
      return action.geod;
    case "CLOSE_GEOD":
      return action.geod;
    default:
      return state;
  }
};

// installation data dispenser
export const intsallationDispenserDataReducers = (state = {}, action) => {
  switch (action.type) {
    case "IntsallationDispenser_Details":
      return {
        workOrderNo: action.workOrderNo,
        productType: action.productType,
        generateUniqueDispenserNo: action.generateUniqueDispenserNo,
        // modelName: action.modelName,
        // mcuBoardSoftwareSrNo: action.mcuBoardSoftwareSrNo,
        // mcuBoardHardwareVersion: action.mcuBoardHardwareVersion,
        // mcuBoardSrNo: action.mcuBoardSrNo,
        // mcuBoardSHA2: action.mcuBoardSHA2,
        // mcuBoardSignXBitBlock: action.mcuBoardSignXBitBlock,
        // mcuBoardPublicKey: action.mcuBoardPublicKey,
        // mcuBoardPrivateKey: action.mcuBoardPrivateKey,
        // mcuBoardRCAPublicKey: action.mcuBoardRCAPublicKey,
        // csdBoardSoftwareSrNo: action.csdBoardSoftwareSrNo,
        // csdBoardHardwareVersion: action.csdBoardHardwareVersion,
        // csdBoardSrNo: action.csdBoardSrNo,
        // csdBoardSHA2: action.csdBoardSHA2,
        // csdBoardSignXBitBlock: action.csdBoardSignXBitBlock,
        // csdBoardPublicKey: action.csdBoardPublicKey,
        // csdBoardPrivateKey: action.csdBoardPrivateKey,
        // csdBoardRCAPublicKey: action.csdBoardRCAPublicKey,
        // mreBoardSoftwareSrNo: action.mreBoardSoftwareSrNo,
        // mreBoardHardwareVersion: action.mreBoardHardwareVersion,
        // mreBoardSrNo: action.mreBoardSrNo,
        // mreBoardSHA2: action.mreBoardSHA2,
        // mreBoardSignXBitBlock: action.mreBoardSignXBitBlock,
        // mreBoardPublicKey: action.mreBoardPublicKey,
        // mreBoardPrivateKey: action.mreBoardPrivateKey,
        // mreBoardRCAPublicKey: action.mreBoardRCAPublicKey,
        // sdlBoardSoftwareSrNo: action.sdlBoardSoftwareSrNo,
        // sdlBoardHardwareVersion: action.sdlBoardHardwareVersion,
        // sdlBoardSrNo: action.sdlBoardSrNo,
        // sdlBoardSHA2: action.sdlBoardSHA2,
        // sdlBoardSignXBitBlock: action.sdlBoardSignXBitBlock,
        // sdlBoardPublicKey: action.sdlBoardPublicKey,
        // sdlBoardPrivateKey: action.sdlBoardPrivateKey,
        // sdlBoardRCAPublicKey: action.sdlBoardRCAPublicKey,
        // board1SoftwareSrNo: action.board1SoftwareSrNo,
        // board1HardwareVersion: action.board1HardwareVersion,
        // board1BoardSrNo: action.board1BoardSrNo,
        // board1BoardSHA2: action.board1BoardSHA2,
        // board1SignXBitBlock: action.board1SignXBitBlock,
        // board1PublicKey: action.board1PublicKey,
        // board1PrivateKey: action.board1PrivateKey,
        // board1RCAPublicKey: action.board1RCAPublicKey,
        // board2SoftwareSrNo: action.board2SoftwareSrNo,
        // board2HardwareVersion: action.board2HardwareVersion,
        // board2BoardSrNo: action.board2BoardSrNo,
        // board2BoardSHA2: action.board2BoardSHA2,
        // board2SignXBitBlock: action.board2SignXBitBlock,
        // board2PublicKey: action.board2PublicKey,
        // board2PrivateKey: action.board2PrivateKey,
        // board2RCAPublicKey: action.board2RCAPublicKey,
        // board3SoftwareSrNo: action.board3SoftwareSrNo,
        // board3HardwareVersion: action.board3HardwareVersion,
        // board3BoardSrNo: action.board3BoardSrNo,
        // board3BoardSHA2: action.board3BoardSHA2,
        // board3SignXBitBlock: action.board3SignXBitBlock,
        // board3PublicKey: action.board3PublicKey,
        // board3PrivateKey: action.board3PrivateKey,
        // board3RCAPublicKey: action.board3RCAPublicKey,
        // board4SoftwareSrNo: action.board4SoftwareSrNo,
        // board4HardwareVersion: action.board4HardwareVersion,
        // board4BoardSrNo: action.board4BoardSrNo,
        // board4BoardSHA2: action.board4BoardSHA2,
        // board4SignXBitBlock: action.board4SignXBitBlock,
        // board4PublicKey: action.board4PublicKey,
        // board4PrivateKey: action.board4PrivateKey,
        // board4RCAPublicKey: action.board4RCAPublicKey,
      };
    default:
      return state;
  }
};




//Add installation
export const addInstallationReducer = (state = {}, action) => {
  switch (action.type) {
    case "AddInstallation_Details":
      return {
        // generateUniqueDispenserNo: action.generateUniqueDispenserNo,
        jobNo: action.jobNo,
        siteName: action.siteName,
        fkServiceEngineerId: action.fkServiceEngineerId,
        serviceEngineerName: action.serviceEngineerName,
        serviceEngineerMobNo: action.serviceEngineerMobNo,
        fkCustomerId: action.fkCustomerId,
        customerName: action.customerName,
        customerMobileNo:action.customerMobileNo,
        fkDealerId: action.fkDealerId,
        dealerName: action.dealerName,
        dealerMobileNo: action.dealerMobileNo,
        siteAddress: action.siteAddress,
        siteType: action.siteType,
        uploadDispenserPhoto: action.uploadDispenserPhoto,
        installationDate: action.installationDate,
        installationTime: action.installationTime,
        installationStatus: action.installationStatus,
        // longitude: action.longitude,
        // latitude: action.latitude,
        remark: action.remark
      };
    default:
      return state;
  }
};
//Add field issue
export const addFieldReducer = (state = {}, action) => {
  switch (action.type) {
    case "AddFieldIssue_Details":
      return {
        jobNo: action.jobNo,
        fkServiceEngineerId: action. fkServiceEngineerId,
        serviceEngineerName: action.serviceEngineerName,
        serviceEngineerMobNo: action.serviceEngineerMobNo,
        siteType: action.siteType,
        siteName: action.siteName,
        fkCustomerId: action.fkCustomerId,
        customerName: action.customerName,
        customerMobileNo: action.customerMobileNo,
        fkDealerId: action.fkDealerId,
        dealerName: action.dealerName,
        dealerMobileNo:action.dealerMobileNo,
        fieldIssueDate:action.fieldIssueDate,
        fieldIssueTime:action.fieldIssueTime,
        siteAddress: action.siteAddress,
        embelDeviceConnect: action.embelDeviceConnect,
        uploadDispenserPhoto: action.uploadDispenserPhoto,
        // longitude: action.longitude,
        // latitude: action.latitude,
        jobType: action.jobType,
        remark: action.remark,
      };
    default:
      return state;
  }
};
//Add field issue Ark
export const addArkFieldReducer = (state = {}, action) => {
  switch (action.type) {
    case "AddArkField_Details":
      return {
        arkNo: action.arkNo,
        // generateUniqueDispenserNo: action.generateUniqueDispenserNo,
        oprationType: action.oprationType,
        subOprationType: action.subOprationType,
        volumeTotalizer: action.volumeTotalizer,
      };
    default:
      return state;
  }
};

//Field issue Data dispenser

export const fieldIssueDispenserDataReducers = (state = {}, action) => {
  switch (action.type) {
    case "FieldDispenser_Details":
      return {
        // workOrderNo: action.workOrderNo,
        workOrderSerialNo: action.workOrderSerialNo,
        // customerName: action.customerName,
        // fkCustomerId: action.fkCustomerId,
        productType: action.productType,
        generateUniqueDispenserNo: action.generateUniqueDispenserNo,
        // modelName: action.modelName,
        // mcuBoardSoftwareSrNo: action.mcuBoardSoftwareSrNo,
        // mcuBoardHardwareVersion: action.mcuBoardHardwareVersion,
        // mcuBoardSrNo: action.mcuBoardSrNo,
        // mcuBoardSHA2: action.mcuBoardSHA2,
        // mcuBoardSignXBitBlock: action.mcuBoardSignXBitBlock,
        // mcuBoardPublicKey: action.mcuBoardPublicKey,
        // mcuBoardPrivateKey: action.mcuBoardPrivateKey,
        // mcuBoardRCAPublicKey: action.mcuBoardRCAPublicKey,
        // csdBoardSoftwareSrNo: action.csdBoardSoftwareSrNo,
        // csdBoardHardwareVersion: action.csdBoardHardwareVersion,
        // csdBoardSrNo: action.csdBoardSrNo,
        // csdBoardSHA2: action.csdBoardSHA2,
        // csdBoardSignXBitBlock: action.csdBoardSignXBitBlock,
        // csdBoardPublicKey: action.csdBoardPublicKey,
        // csdBoardPrivateKey: action.csdBoardPrivateKey,
        // csdBoardRCAPublicKey: action.csdBoardRCAPublicKey,
        // mreBoardSoftwareSrNo: action.mreBoardSoftwareSrNo,
        // mreBoardHardwareVersion: action.mreBoardHardwareVersion,
        // mreBoardSrNo: action.mreBoardSrNo,
        // mreBoardSHA2: action.mreBoardSHA2,
        // mreBoardSignXBitBlock: action.mreBoardSignXBitBlock,
        // mreBoardPublicKey: action.mreBoardPublicKey,
        // mreBoardPrivateKey: action.mreBoardPrivateKey,
        // mreBoardRCAPublicKey: action.mreBoardRCAPublicKey,
        // sdlBoardSoftwareSrNo: action.sdlBoardSoftwareSrNo,
        // sdlBoardHardwareVersion: action.sdlBoardHardwareVersion,
        // sdlBoardSrNo: action.sdlBoardSrNo,
        // sdlBoardSHA2: action.sdlBoardSHA2,
        // sdlBoardSignXBitBlock: action.sdlBoardSignXBitBlock,
        // sdlBoardPublicKey: action.sdlBoardPublicKey,
        // sdlBoardPrivateKey: action.sdlBoardPrivateKey,
        // sdlBoardRCAPublicKey: action.sdlBoardRCAPublicKey,
        // board1SoftwareSrNo: action.board1SoftwareSrNo,
        // board1HardwareVersion: action.board1HardwareVersion,
        // board1BoardSrNo: action.board1BoardSrNo,
        // board1BoardSHA2: action.board1BoardSHA2,
        // board1SignXBitBlock: action.board1SignXBitBlock,
        // board1PublicKey: action.board1PublicKey,
        // board1PrivateKey: action.board1PrivateKey,
        // board1RCAPublicKey: action.board1RCAPublicKey,
        // board2SoftwareSrNo: action.board2SoftwareSrNo,
        // board2HardwareVersion: action.board2HardwareVersion,
        // board2BoardSrNo: action.board2BoardSrNo,
        // board2BoardSHA2: action.board2BoardSHA2,
        // board2SignXBitBlock: action.board2SignXBitBlock,
        // board2PublicKey: action.board2PublicKey,
        // board2PrivateKey: action.board2PrivateKey,
        // board2RCAPublicKey: action.board2RCAPublicKey,
        // board3SoftwareSrNo: action.board3SoftwareSrNo,
        // board3HardwareVersion: action.board3HardwareVersion,
        // board3BoardSrNo: action.board3BoardSrNo,
        // board3BoardSHA2: action.board3BoardSHA2,
        // board3SignXBitBlock: action.board3SignXBitBlock,
        // board3PublicKey: action.board3PublicKey,
        // board3PrivateKey: action.board3PrivateKey,
        // board3RCAPublicKey: action.board3RCAPublicKey,
        // board4SoftwareSrNo: action.board4SoftwareSrNo,
        // board4HardwareVersion: action.board4HardwareVersion,
        // board4BoardSrNo: action.board4BoardSrNo,
        // board4BoardSHA2: action.board4BoardSHA2,
        // board4SignXBitBlock: action.board4SignXBitBlock,
        // board4PublicKey: action.board4PublicKey,
        // board4PrivateKey: action.board4PrivateKey,
        // board4RCAPublicKey: action.board4RCAPublicKey,
      };
    default:
      return state;
  }
};

//Calibration Data dispenser

export const calibrationDispenserDataReducers = (state = {}, action) => {
  switch (action.type) {
    case "CalibrationDispenser_Details":
      return {
        // workOrderNo: action.workOrderNo,
        workOrderSerialNo: action.workOrderSerialNo, // bhushan
        productType: action.productType,
        generateUniqueDispenserNo: action.generateUniqueDispenserNo,
        // modelName: action.modelName,
        // mcuBoardSoftwareSrNo: action.mcuBoardSoftwareSrNo,
        // mcuBoardHardwareVersion: action.mcuBoardHardwareVersion,
        // mcuBoardSrNo: action.mcuBoardSrNo,
        // mcuBoardSHA2: action.mcuBoardSHA2,
        // mcuBoardSignXBitBlock: action.mcuBoardSignXBitBlock,
        // mcuBoardPublicKey: action.mcuBoardPublicKey,
        // mcuBoardPrivateKey: action.mcuBoardPrivateKey,
        // mcuBoardRCAPublicKey: action.mcuBoardRCAPublicKey,
        // csdBoardSoftwareSrNo: action.csdBoardSoftwareSrNo,
        // csdBoardHardwareVersion: action.csdBoardHardwareVersion,
        // csdBoardSrNo: action.csdBoardSrNo,
        // csdBoardSHA2: action.csdBoardSHA2,
        // csdBoardSignXBitBlock: action.csdBoardSignXBitBlock,
        // csdBoardPublicKey: action.csdBoardPublicKey,
        // csdBoardPrivateKey: action.csdBoardPrivateKey,
        // csdBoardRCAPublicKey: action.csdBoardRCAPublicKey,
        // mreBoardSoftwareSrNo: action.mreBoardSoftwareSrNo,
        // mreBoardHardwareVersion: action.mreBoardHardwareVersion,
        // mreBoardSrNo: action.mreBoardSrNo,
        // mreBoardSHA2: action.mreBoardSHA2,
        // mreBoardSignXBitBlock: action.mreBoardSignXBitBlock,
        // mreBoardPublicKey: action.mreBoardPublicKey,
        // mreBoardPrivateKey: action.mreBoardPrivateKey,
        // mreBoardRCAPublicKey: action.mreBoardRCAPublicKey,
        // sdlBoardSoftwareSrNo: action.sdlBoardSoftwareSrNo,
        // sdlBoardHardwareVersion: action.sdlBoardHardwareVersion,
        // sdlBoardSrNo: action.sdlBoardSrNo,
        // sdlBoardSHA2: action.sdlBoardSHA2,
        // sdlBoardSignXBitBlock: action.sdlBoardSignXBitBlock,
        // sdlBoardPublicKey: action.sdlBoardPublicKey,
        // sdlBoardPrivateKey: action.sdlBoardPrivateKey,
        // sdlBoardRCAPublicKey: action.sdlBoardRCAPublicKey,
        // board1SoftwareSrNo: action.board1SoftwareSrNo,
        // board1HardwareVersion: action.board1HardwareVersion,
        // board1BoardSrNo: action.board1BoardSrNo,
        // board1BoardSHA2: action.board1BoardSHA2,
        // board1SignXBitBlock: action.board1SignXBitBlock,
        // board1PublicKey: action.board1PublicKey,
        // board1PrivateKey: action.board1PrivateKey,
        // board1RCAPublicKey: action.board1RCAPublicKey,
        // board2SoftwareSrNo: action.board2SoftwareSrNo,
        // board2HardwareVersion: action.board2HardwareVersion,
        // board2BoardSrNo: action.board2BoardSrNo,
        // board2BoardSHA2: action.board2BoardSHA2,
        // board2SignXBitBlock: action.board2SignXBitBlock,
        // board2PublicKey: action.board2PublicKey,
        // board2PrivateKey: action.board2PrivateKey,
        // board2RCAPublicKey: action.board2RCAPublicKey,
        // board3SoftwareSrNo: action.board3SoftwareSrNo,
        // board3HardwareVersion: action.board3HardwareVersion,
        // board3BoardSrNo: action.board3BoardSrNo,
        // board3BoardSHA2: action.board3BoardSHA2,
        // board3SignXBitBlock: action.board3SignXBitBlock,
        // board3PublicKey: action.board3PublicKey,
        // board3PrivateKey: action.board3PrivateKey,
        // board3RCAPublicKey: action.board3RCAPublicKey,
        // board4SoftwareSrNo: action.board4SoftwareSrNo,
        // board4HardwareVersion: action.board4HardwareVersion,
        // board4BoardSrNo: action.board4BoardSrNo,
        // board4BoardSHA2: action.board4BoardSHA2,
        // board4SignXBitBlock: action.board4SignXBitBlock,
        // board4PublicKey: action.board4PublicKey,
        // board4PrivateKey: action.board4PrivateKey,
        // board4RCAPublicKey: action.board4RCAPublicKey,
      };
    default:
      return state;
  }
};
//calibration Ark details
export const addArkcalibrationReducer = (state = {}, action) => {
  switch (action.type) {
    case "AddArkCalibration_Details":
      return {
        arkNo: action.arkNo,
        // generateUniqueDispenserNo: action.generateUniqueDispenserNo,
        oprationType: action.oprationType,
        subOprationType: action.subOprationType,
        volumeTotalizer: action.volumeTotalizer,
      };
    default:
      return state;
  }
};

//add calibration
export const addcalibrationReducer = (state = {}, action) => {
  switch (action.type) {
    case "AddCalibration_Details":
      return {
        jobNo: action.jobNo,
        calibrationDate: action.calibrationDate,
        calibrationTime: action.calibrationTime,
        inspectorName: action.inspectorName,
        inspectorMobileNo: action.inspectorMobileNo,
        fkCustomerId: action.fkCustomerId,
        customerName: action.customerName,
        customerMobileNo:action.customerMobileNo,
        fkDealerId: action.fkDealerId,
        dealerName: action.dealerName,
        dealerMobileNo: action.dealerMobileNo,
        siteType: action.siteType,
        fkServiceEngineerId: action.fkServiceEngineerId,
        serviceEngineerName: action.serviceEngineerName,
        serviceEngineerMobNo: action.serviceEngineerMobNo,
        calibrationCertificate: action.calibrationCertificate,
        certificateDatePhoto: action.certificateDatePhoto,
        certificateSignature: action.certificateSignature,
        digitalSignature: action.digitalSignature,
        siteReportUpload: action.siteReportUpload,
        calibrationLogView: action.calibrationLogView,
        sitePhoto: action.sitePhoto,
        certificateDate: action.certificateDate,
        // longitude: action.longitude,
        // latitude: action.latitude,
        remark: action.remark,
      };
    default:
      return state;
  }
};

export const reducers = combineReducers({
  geod,
  intsallationDispenserDataReducers,
  addInstallationReducer,
  addFieldReducer,
  addArkFieldReducer,
  fieldIssueDispenserDataReducers,
  calibrationDispenserDataReducers,
  addArkcalibrationReducer,
  addcalibrationReducer
});

const persistedReducer = persistReducer(persistConfig, reducers);

//store.js
export const configureStore = () => {
  const store = createStore(persistedReducer);
  return store;
};

const store = configureStore();

console.log("----.", store.getState());

const persistor = persistStore(store);

export { store, persistor };
